/**
 * Giải mã payload JWT (base64url + padding). `atob` trực tiếp trên segment JWT thường throw (InvalidCharacterError).
 */
export function decodeJwtPayload(accessToken: string): Record<string, unknown> | null {
  try {
    const parts = accessToken.split('.')
    if (parts.length < 2 || !parts[1]) return null
    let b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const rem = b64.length % 4
    if (rem) b64 += '='.repeat(4 - rem)
    const json = atob(b64)
    return JSON.parse(json) as Record<string, unknown>
  } catch {
    return null
  }
}

export function getJwtExp(accessToken: string): number | undefined {
  const raw = decodeJwtPayload(accessToken)?.exp
  if (typeof raw === 'number' && Number.isFinite(raw)) return raw
  if (typeof raw === 'string') {
    const n = Number(raw)
    return Number.isFinite(n) ? n : undefined
  }
  return undefined
}
